module.exports = __webpack_public_path__ + "img/bx-teaching-time.33370650.svg";